import React from 'react'
import logo from '../images/bati_grup_logo.png'

export default function Header() {
    return (
        <div style={{ textAlign: "center" }}><img src={logo} alt="BATIGRUP" title="BATIGRUP" /></div>
    )
}
